import React from "react"

import {Feature} from "../../gd/access-control/feature-access/const"

type Props = {
    isCustom    : boolean
    children    : React.ReactNode
}

// Free plan keeps existing custom fields readable but not editable
export function areCustomFieldsLocked(): boolean {
    return !gd.company.license.customFields
}

export function showCustomFieldsUpgrade() {
    gd.modals.other.upgradeToPro(Feature.CUSTOM_FIELDS)
}

// Intercepts any attempt to interact with the wrapped editor and shows the upgrade modal instead
export default function CustomFieldUpgradeGuard(props: Props): any {

    if (
        !props.isCustom
        || !areCustomFieldsLocked()
    ) {
        return props.children
    }

    const block = (e: React.SyntheticEvent) => {
        e.preventDefault()
        e.stopPropagation()
    }

    const onClick = (e: React.SyntheticEvent) => {
        block(e)
        showCustomFieldsUpgrade()
    }

    const onFocus = (e: React.FocusEvent) => {
        e.stopPropagation();
        (e.target as HTMLElement).blur()
        showCustomFieldsUpgrade()
    }

    return (
        <div style              = {{display: 'contents'}}
             onMouseDownCapture = {block}
             onKeyDownCapture   = {block}
             onFocusCapture     = {onFocus}
             onClickCapture     = {onClick}
        >
            {props.children}
        </div>
    )
}
